export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export const gridColumns = [
  {
    headerName: 'Nominee',
    field: 'nominee',
    flex: 1,
    minWidth: 200,
    valueGetter: (params) => params.data.identification,
  },
  {
    headerName: 'Triennium',
    field: 'status',
    minWidth: 200,
    valueGetter: (params) => {
      const nomination = params.data;
      return `${nomination.award.triennium.from} - ${nomination.award.triennium.to}`;
    },
  },
  {
    headerName: 'Global Grade',
    field: 'global_grade',
    minWidth: 200,
    valueGetter: (params) => params.data.reports[0]?.global_grade,
  },
];
